import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router';
import { Row, Col } from 'reactstrap'
import { getLocalStorageInfo } from '../../../../utils'
import InvFields from './InvFields'
import { titanInstance } from '../../../../shared_elements/components';

class BankingInfo extends Component{
  constructor(props){
    super(props)
    this.state = {
      showFullRemarks: false,
    }
  }
  toggleFooterNote = () => {
    this.setState((prevState) => ({ showFullRemarks: !prevState.showFullRemarks }));
  };
  render(){
    const { type, invoiceInfo, error, assemblyInvoice } = this.props
    const disablePermission = getLocalStorageInfo().defaultLessor.id===442 || titanInstance
    const numericWithHyphen = /^[\d\-]+$/
    if(type === 'view'){
      return(
        <div className="bank-detail-block " style={assemblyInvoice ? {background:'#f5f7fa', padding:'10px'}:{}} >
          <Row>
            <InvFields label="Name" colSize="4" value={invoiceInfo.bank_name?invoiceInfo.bank_name:'--'}  />
            <InvFields label="Account Name" colSize="4" value={invoiceInfo.bank_account_name?invoiceInfo.bank_account_name:'--'}  />
            <InvFields label="Account Number" colSize="4" value={invoiceInfo.bank_account_number?invoiceInfo.bank_account_number:'--'}  />
            <InvFields label={getLocalStorageInfo().defaultLessor.id==14?"ABA Code":"IBAN Code"} colSize="4" value={invoiceInfo.bank_iban?invoiceInfo.bank_iban:'--'}  />
            <InvFields label="ABA Number" colSize="4" value={invoiceInfo.aba_number?invoiceInfo.aba_number:'--'}  />
            <InvFields label="SWIFT Code" colSize="4" value={invoiceInfo.bank_swift_code?invoiceInfo.bank_swift_code:'--'}  />
            <InvFields label="SORT Code" colSize="4" value={invoiceInfo.bank_sort_code?invoiceInfo.bank_sort_code:'--'}  />
            {[14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
                <Fragment>
                  <InvFields label="VAT number" colSize = "4"  value={invoiceInfo.vat_number? invoiceInfo.vat_number:'--'}  />
                  <InvFields label="Hub account" colSize = "4"  value={invoiceInfo.hub_number? invoiceInfo.hub_number:'--'}  />
                  <InvFields label="Customer Reference Number" colSize ="4"  value={ invoiceInfo.customer_reference_number ? invoiceInfo.customer_reference_number  :'--'}  />
                </Fragment>
                :null
              }
            <InvFields label="Footer Note" colSize="8" value={invoiceInfo.footer_note ? (titanInstance?
            invoiceInfo.footer_note && invoiceInfo.footer_note.length > 200 ? (
            <div>
              {this.state.showFullRemarks ? (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: invoiceInfo.footer_note.replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleFooterNote(); }}>
                    less
                  </a>
                </span>
              ) : (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: invoiceInfo.footer_note.substring(0, 190).replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleFooterNote(); }}>
                    ..more
                  </a>
                </span>
              )}
            </div>
          ) : (
            <div>{invoiceInfo.footer_note !== '--' ? <span dangerouslySetInnerHTML={{ __html: invoiceInfo.footer_note.replace(/\n/g, '<br />') }} /> : '--'}</div>
          ):invoiceInfo.footer_note):'--'}  />
          </Row>
        </div>
      )
    }else{
      return(
        <div className="bank-detail-block" style={assemblyInvoice ? {background:'#f5f7fa', padding:'10px'}:{}} >
          <Row>
            <Col md="4">
              <div className="form-group">
                <label className="label">Name</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.bank_name}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_name')}
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
                <h6 className="error-msg">{error.bank_name}</h6>
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">Account Name</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.bank_account_name}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_account_name')}
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
                 <h6 className="error-msg">{error.bank_account_name}</h6>
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">Account Number</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.bank_account_number}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_account_number')}
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
                 <h6 className="error-msg">{error.bank_account_number}</h6>
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">{getLocalStorageInfo().defaultLessor.id==14?"ABA Code":"IBAN Code"}</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.bank_iban}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_iban')}
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">ABA Number</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.aba_number}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'aba_number')}
                  maxlength="50"
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">SWIFT Code</label>
                <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.bank_swift_code}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_swift_code')}
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
              </div>
            </Col>
            <Col md="4">
              <div className="form-group">
                <label className="label">SORT Code</label>
                <input
                 className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''}
                  type="text"
                  value={invoiceInfo.bank_sort_code}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'bank_sort_code')}
                  maxLength="20"
                  disabled={disablePermission}
                  style={{cursor:disablePermission?'not-allowed':'text'}}
                />
              </div>
            </Col>
            {[14,242].includes(getLocalStorageInfo().defaultLessor.id) ?
              <Fragment>
                <Col md="4">
                  <div className="form-group">
                    <label className="label">Hub Account</label>
                    <input
                    className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''}
                      type="text"
                      value={invoiceInfo.hub_number}
                      onChange={(e) =>  this.props.updateInvoiceField(e.target.value, 'hub_number') }
                      maxLength="20"
                    />
                  </div>
                </Col><Col md="4">
                  <div className="form-group">
                    <label className="label">VAT Number</label>
                    <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.vat_number}
                      onChange={(e) => this.props.updateInvoiceField(e.target.value, 'vat_number')}
                    />
                  </div>
                </Col><Col md="4">
                  <div className="form-group">
                    <label className="label">Customer Reference Number</label>
                    <input className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color':''} type="text" value={invoiceInfo.customer_reference_number}
                      onChange={(e) => this.props.updateInvoiceField(e.target.value, 'customer_reference_number')}
                    />
                  </div>
                </Col>

              </Fragment> : null

            }
            <Col md="8">
              <div className="form-group">
                <label className="label">Footer Note</label>
                {!titanInstance ?
                <input
                  className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color' : ''}
                  type="text"
                  value={invoiceInfo.footer_note}
                  onChange={(e) => this.props.updateInvoiceField(e.target.value, 'footer_note')}
                />
                :
                  <textarea
                    ref={(el) => { if (el){ el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; this.textareaRef = el; } }}
                    className={assemblyInvoice ? 'assembly-invoice-lessor-input input-bg-color' : ''}
                    maxLength={1500}
                    value={invoiceInfo.footer_note}
                    onChange={(e) => {
                      this.props.updateInvoiceField( e.target.value.split('\n').slice(0, 15).join('\n'), 'footer_note');
                      e.target.style.height = 'auto';
                      e.target.style.height = e.target.scrollHeight + 'px';}} 
                  />}
              </div>
            </Col>
          </Row>
        </div>
      )
    }
  }
}
export default withRouter(BankingInfo);
